import { Component, h, Prop } from '@stencil/core';

/**
 * Horizontal feature card with text content on the left and media image on the right.
 * Supports default and dark visual variants. Unique among feature cards for its side-by-side layout.
 * Standalone card component not currently tied to a specific section type.
 *
 * @category Features
 * @slot media - <me-picture aspectRatio="1.95 / 1">
 * @slot heading - {required}, <me-heading variant=["4", "5"]> -
 *   IMPORTANT: If prop `variant='1'` - set `me-heading variant='4'`; if prop `variant='2'` - set `me-heading variant='5'`
 * @slot description - {required}, <me-text>
 * @slot actions - {required}, <me-button variant="ghost" icon="arrows--chevron-right" iconPosition="after">
 * @example
 *   <features-card-type-4 variant="default">
 *     <me-picture slot="media" src="https://images.unsplash.com/photo-1557683304-673a23048d34?w=800&h=410&fit=crop" aspect-ratio="1.95 / 1" alt="Analytics feature"></me-picture>
 *     <me-heading slot="heading" variant="4">Real-Time Analytics</me-heading>
 *     <me-text slot="description">Monitor your key metrics and make data-driven decisions.</me-text>
 *     <me-button slot="actions" variant="ghost" icon="arrows--chevron-right" icon-position="after">Explore</me-button>
 *   </features-card-type-4>
 */

@Component({
  tag: 'features-card-type-4',
  styleUrl: 'index.scss',
  shadow: false,
})
export class FeaturesCardType4 {
  /**
   * Card visual variant: '1' (default) or '2', '3'.
   */
  @Prop() variant: 'default' | 'dark' = 'default';

  render() {
    const variantClass = `features-card-type-4--variant-${this.variant}`;
    return (
      <div class={`features-card-type-4 ${variantClass}`}>
        <div class="features-card__info">
          <slot name="heading"></slot>
          <slot name="description"></slot>
          <slot name="actions"></slot>
        </div>
        <div class="features-card__image">
          <slot name="media"></slot>
        </div>
      </div>
    );
  }
}
